export const defaultHDBitrate = 1500000;
export const defaultHDResolution = 720;

export const defaultSimulcastMaxBitrates = {
  high: defaultHDBitrate,
  medium: 700000,
  low: 128000,
};

export const screenshareSimulcastMaxBitrates = {
  high: defaultHDBitrate,
  low: 128000,
};
